import EntitySelector from '@components/EntitySelector'

type EntityType = 'Agency' | 'Brand' | 'Provider' | 'System'

const entityTypeSettings = {
  Agency: {
    label: 'Agency',
    entityKey: 'agencies',
  },
  Brand: {
    label: 'Brand',
    entityKey: 'brands',
  },
  Provider: {
    label: 'Provider',
    entityKey: 'providers',
  },
  System: {
    label: 'System',
    entityKey: 'systems',
  },
}

const renderLabel = (params: {
  customLabel: string,
  label: string,
  required: boolean,
}) => {
  const { customLabel, label, required } = params

  if (customLabel) return customLabel
  return required ? `# ${label}` : label
}

interface OrganizationSelectorProps {
  boxProps?: object,
  callbacks: {
    selectItem: (entity: object) => void,
  },
  entityType: EntityType,
  label?: string,
  marginTop?: number | string,
  required?: boolean,
  searchRequestOptions?: { [key: string]: any },
  selectedItemId: number,
}

const OrganizationSelector = (props: OrganizationSelectorProps) => {
  const {
    boxProps,
    callbacks: { selectItem },
    label: customLabel,
    entityType,
    marginTop,
    required = false,
    searchRequestOptions,
    selectedItemId,
  } = props

  const { entityKey, label } = entityTypeSettings[entityType as EntityType]

  return (
    <EntitySelector
      boxProps={boxProps}
      // @ts-expect-error TS2741
      callbacks={{
        selectItem: entity => selectItem({ entity, entityType }),
      }}
      // @ts-expect-error TS2322
      label={renderLabel({ customLabel, label, required })}
      entityKey={entityKey}
      marginTop={marginTop}
      searchRequestOptions={searchRequestOptions}
      selectedItemId={selectedItemId}
    />
  )
}

export default OrganizationSelector
